import { c as _c } from "react/compiler-runtime";
import { Table } from '@systemeio/components';
import { onChangeRuleStatus, onDeleteRule } from 'modules/automation-rules/api/automation-rules-api';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import { triggerActionLocoKeys, triggerDescriptionLocoKeys } from 'modules/automation-rules/triggers/constants/trigger-loco-keys';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRuleApiInterface, AutomationRuleInterface } from 'modules/automation-rules/types/automation-rule-interface';
import type { ReactNode } from 'react';
import { Hint } from 'shared/components';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { EmptyListState } from 'shared/components/empty-states';
import { StatusCell } from 'shared/components/table/cells/status-cell';
import { ActionsRender } from 'shared/components/table/components/actions-render';
import { ActionsInterface } from 'shared/components/table/components/actions-render/types';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
import { twMerge } from 'tailwind-merge';
interface SpecificTriggerRulesTableProps extends Pick<SpecificTriggerRulesProps, 'getRelatedAndUnrelatedTriggersData' | 'noRelatedMessage'> {
  rules?: AutomationRuleApiInterface;
  mutateRules: KeyedMutator<AutomationRuleApiInterface>;
  setSelectedRuleId: (ruleId: number) => void;
  mutateAvailableTriggers: KeyedMutator<AutomationRuleTriggersEnum[]>;
  emptyStateAction?: ReactNode;
}
const SpecificTriggerRulesTable = t0 => {
  const $ = _c(82);
  const {
    rules,
    mutateRules,
    setSelectedRuleId,
    mutateAvailableTriggers,
    getRelatedAndUnrelatedTriggersData,
    noRelatedMessage,
    emptyStateAction
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== mutateRules) {
    t1 = async rule => {
      await onChangeRuleStatus(rule.active, rule.id);
      await mutateRules(data => data && {
        ...data,
        items: data.items.map(el => {
          if (el.id === rule.id) {
            return {
              ...el,
              active: !el.active
            };
          }
          return el;
        })
      }, false);
    };
    $[0] = mutateRules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const changeRuleStatus = t1;
  let t2;
  if ($[2] !== mutateAvailableTriggers || $[3] !== mutateRules) {
    t2 = async rule_0 => {
      await onDeleteRule(rule_0.id);
      await mutateRules(data_0 => data_0 && {
        ...data_0,
        items: data_0.items.filter(el_0 => el_0.id !== rule_0.id)
      }, false);
      await mutateAvailableTriggers();
    };
    $[2] = mutateAvailableTriggers;
    $[3] = mutateRules;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const deleteRule = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.automation_rule.edit.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== setSelectedRuleId) {
    t4 = rule_1 => setSelectedRuleId(rule_1.id);
    $[7] = setSelectedRuleId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      name: "edit-rule",
      caption: t3,
      onActionClick: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("dashboard.automation_rule.edit.enable");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== changeRuleStatus || $[15] !== t) {
    t7 = (opened, onClose, instance, key) => <ConfirmationModal key={key} confirmationText={t("dashboard.automation_rule.edit.enable_confirm")} toastCaption={t("dashboard.automation_rule.edit.enable_success")} opened={opened} onClose={onClose} onConfirm={() => changeRuleStatus(instance)} />;
    $[14] = changeRuleStatus;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      name: "enable-rule",
      caption: t6,
      shouldRender: _temp,
      onActionRender: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.automation_rule.edit.disable");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== changeRuleStatus || $[23] !== t) {
    t10 = (opened_0, onClose_0, instance_0, key_0) => <ConfirmationModal key={key_0} confirmationText={t("dashboard.automation_rule.edit.disable_confirm")} toastCaption={t("dashboard.automation_rule.edit.disable_success")} opened={opened_0} onClose={onClose_0} onConfirm={() => changeRuleStatus(instance_0)} />;
    $[22] = changeRuleStatus;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      name: "disable-rule",
      caption: t9,
      shouldRender: _temp2,
      onActionRender: t10
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("dashboard.automation_rule.edit.delete");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== deleteRule || $[31] !== getRelatedAndUnrelatedTriggersData || $[32] !== t) {
    t13 = (opened_1, onClose_1, instance_1, key_1) => {
      const {
        unrelatedTriggers
      } = getRelatedAndUnrelatedTriggersData(instance_1.triggers);
      const hasUnrelatedTriggers = unrelatedTriggers.length !== 0;
      return <ConfirmationModal status="error" key={key_1} toastCaption={t("dashboard.automation_rule.edit.delete_success")} confirmationText={hasUnrelatedTriggers ? <TransLoco t={t} i18nKey="dashboard.funnel.automation_rules.delete_rule.confirmation" components={{
        b: <b />
      }} /> : t("dashboard.automation_rule.edit.delete_confirm")} opened={opened_1} onClose={onClose_1} onConfirm={() => deleteRule(instance_1)} />;
    };
    $[30] = deleteRule;
    $[31] = getRelatedAndUnrelatedTriggersData;
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13) {
    t14 = {
      name: "delete-rule",
      caption: t12,
      onActionRender: t13
    };
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t11 || $[38] !== t14 || $[39] !== t5 || $[40] !== t8) {
    t15 = {
      custom: [t5, t8, t11, t14]
    };
    $[37] = t11;
    $[38] = t14;
    $[39] = t5;
    $[40] = t8;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  const actions = t15;
  let t16;
  if ($[42] !== getRelatedAndUnrelatedTriggersData || $[43] !== noRelatedMessage || $[44] !== t) {
    t16 = rule_4 => {
      const {
        relatedTriggers,
        unrelatedTriggers: unrelatedTriggers_0
      } = getRelatedAndUnrelatedTriggersData(rule_4.triggers);
      return <Hint showHint={unrelatedTriggers_0.length !== 0} label={noRelatedMessage(rule_4.id)}><div className="flex min-w-0 flex-col">{relatedTriggers.map((trigger, index) => <div key={`${trigger.type}-${index}`} className={twMerge("flex min-w-0 flex-col gap-1 py-3", index !== 0 && "border-border-100 border-t", index === 0 && "pt-0", index === relatedTriggers.length - 1 && "pb-0")}><span className="text-text-primary truncate text-base font-medium">{t(triggerActionLocoKeys[trigger.type])}</span><span className="text-text-tertiary truncate text-sm">{t(triggerDescriptionLocoKeys[trigger.type])}</span></div>)}</div></Hint>;
    };
    $[42] = getRelatedAndUnrelatedTriggersData;
    $[43] = noRelatedMessage;
    $[44] = t;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const renderRuleSummary = t16;
  let t17;
  if ($[46] !== actions) {
    t17 = rule_5 => <div><ActionsRender actions={actions} instance={rule_5} rowId={rule_5.id} /></div>;
    $[46] = actions;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  const renderActions = t17;
  if (rules?.items.length === 0) {
    let t18;
    if ($[48] !== t) {
      t18 = t("dashboard.funnel.automation_rules.empty.title");
      $[48] = t;
      $[49] = t18;
    } else {
      t18 = $[49];
    }
    let t19;
    if ($[50] !== t) {
      t19 = t("dashboard.funnel.automation_rules.empty.description");
      $[50] = t;
      $[51] = t19;
    } else {
      t19 = $[51];
    }
    let t20;
    if ($[52] !== emptyStateAction || $[53] !== t18 || $[54] !== t19) {
      t20 = <EmptyListState className="max-w-80 px-0 py-0" title={t18} description={t19}>{emptyStateAction}</EmptyListState>;
      $[52] = emptyStateAction;
      $[53] = t18;
      $[54] = t19;
      $[55] = t20;
    } else {
      t20 = $[55];
    }
    return t20;
  }
  let t18;
  if ($[56] !== t) {
    t18 = t("dashboard.funnel.automation_rules.title");
    $[56] = t;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Table.Header className="hidden"><Table.Head id="triggers" /><Table.Head id="status" /><Table.Head id="actions" className="w-18" /></Table.Header>;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== renderActions || $[60] !== renderRuleSummary || $[61] !== rules) {
    t20 = rules ? rules.items.map(rule_6 => <Table.Row key={rule_6.id} id={rule_6.id}><Table.Cell>{renderRuleSummary(rule_6)}</Table.Cell><Table.Cell className="w-28"><StatusCell isActive={rule_6.active} /></Table.Cell><Table.Cell className="w-18">{renderActions(rule_6)}</Table.Cell></Table.Row>) : <Table.Row id="loader"><Table.LoaderCell /><Table.LoaderCell className="w-28" /><Table.LoaderCell className="w-18" /></Table.Row>;
    $[59] = renderActions;
    $[60] = renderRuleSummary;
    $[61] = rules;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t20) {
    t21 = <Table.Body>{t20}</Table.Body>;
    $[63] = t20;
    $[64] = t21;
  } else {
    t21 = $[64];
  }
  let t22;
  if ($[65] !== t18 || $[66] !== t21) {
    t22 = <div className="max-tablet:hidden"><Table.Root aria-label={t18} className="table-fixed">{t19}{t21}</Table.Root></div>;
    $[65] = t18;
    $[66] = t21;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== t) {
    t23 = t("dashboard.funnel.automation_rules.title");
    $[68] = t;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  let t24;
  if ($[70] !== renderActions || $[71] !== renderRuleSummary || $[72] !== rules) {
    t24 = rules ? rules.items.map(rule_7 => <Table.Mobile.Card key={rule_7.id} id={rule_7.id} className="min-h-16 px-4 py-0"><div className="flex min-h-16 items-center gap-3"><div className="min-w-0 flex-1">{renderRuleSummary(rule_7)}</div><StatusCell isActive={rule_7.active} />{renderActions(rule_7)}</div></Table.Mobile.Card>) : <Table.Mobile.Card className="min-h-16 px-4 py-0"><div className="flex min-h-16 items-center gap-3"><Table.Mobile.LoaderCell className="min-w-0 flex-1" /><Table.Mobile.LoaderCell className="w-20" /><Table.Mobile.LoaderCell className="w-6" /></div></Table.Mobile.Card>;
    $[70] = renderActions;
    $[71] = renderRuleSummary;
    $[72] = rules;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  let t25;
  if ($[74] !== t24) {
    t25 = <Table.Mobile.Body>{t24}</Table.Mobile.Body>;
    $[74] = t24;
    $[75] = t25;
  } else {
    t25 = $[75];
  }
  let t26;
  if ($[76] !== t23 || $[77] !== t25) {
    t26 = <div className="tablet:hidden"><Table.Mobile.Root aria-label={t23}>{t25}</Table.Mobile.Root></div>;
    $[76] = t23;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== t22 || $[80] !== t26) {
    t27 = <div className="border-border-100 bg-bg-primary w-full overflow-hidden rounded-xl border">{t22}{t26}</div>;
    $[79] = t22;
    $[80] = t26;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  return t27;
};
export default SpecificTriggerRulesTable;
function _temp(rule_2) {
  return !rule_2.active;
}
function _temp2(rule_3) {
  return rule_3.active;
}